import { mapChapterToApiName, mapChapterToNewName } from "./chapter-mapping";

export const API_UPLOAD_EXCEL = "/users/import";
export const API_STUDENT_DETAILS = "/users";
export const API_ASPIRANT_DETAILS = "/aspirants";
export const API_TEACHER_DETAILS = "/teachers";
export const API_DELETE_STUDENT = "/users/remove";
export const apiStudentStudys = (email) => `/api/users/info?email=${email}`;
export const API_MEDIUMS = "/mediums";
export const API_SUBJECTS = "/subjects";
export const API_CHAPTERS = "/chapters";
export const API_AI_CONTENT_CHAPTERS = "ai-content/chapters";
export const API_AI_CONCEPTS_DROPDOWN = "ai-content/upsc/concepts";
export const API_AI_CONCEPTS_DROPDOWN_STUDENTS = "ai-content/students/concepts";
export const API_EXAM_AI_CONCEPTS_DROPDOWN = "/ai-content/exam/concepts";
export const API_TNPSC_AI_CONCEPTS_DROPDOWN = "/ai-content/tnpsc/concepts";
export const API_LOGIN = "/login";
export const API_SIGN_UP = "/signup";
export const API_SIGN_UP_V1 = "/v1/signup";
export const API_RESET_PASSWORD = "/reset-password";
export const API_GET_MCQ = "/mcq";
export const API_MCQ = "/ask";
export const API_MCQ_SUBJECTS = "/mcq/subjects";
export const API_MCQ_CHAPTERS = "/mcq/chapters";
export const API_EVALUATE = "/evaluate";
export const API_REMOVE_MULTIPLE = "/users/remove-multiple";
export const API_SCHOOL_DETAILS = "/schools";
export const API_GENERATE_VIDEO = "/student/generate-video";
export const apiGetMyStuff = (email) => `/my-short-stuff?email=${email}`;
export const APISHORTMULTI = "/shorts/multi";
export const apiChatHistory = (email, limit) =>
  `/chat/history?email=${email}&limit=${limit}`;
export const apiChatHistoryFilter = (email, subject, chapter, section) =>
  `/chat/history/filter?email=${email}&subject=${subject}&chapter=${chapter}&section=${section}`;
export const APILONGMULTI = "/long-job/multi";
export const APIRANDOMMULTI = "/random/content";
export const API_NOTIFICATIONS = "notifications/notifications";
export const API_READ_NOTIFICATIONS = "notifications/notifications/read";
export const API_DEACTIVATE_USERS = "/users/deactivate-multiple";
export const API_ACTIVATE_USERS = "/users/activate-multiple";
export const apiMyAssests = (
  email,
  board,
  type,
  status,
  language,
  sort,
  subject,
  chapter,
  include_hidden,
  on_date,
  from_date,
  to_date,
) => {
  let url = `/my-assets?email=${email}&board=${board}&type=${type}&sort=${sort}`;
  if (status) url += `&status=${status}`;
  if (language) url += `&language=${language}`;
  if (subject) url += `&subject=${subject}`;
  if (chapter) url += `&chapter=${chapter}`;
  if (include_hidden) url += `&include_hidden=${include_hidden}`;
  if (on_date) url += `&on_date=${on_date}`;
  if (from_date) url += `&from_date=${from_date}`;
  if (to_date) url += `&to_date=${to_date}`;
  return url;
};
export const apiMyAssestsSearch = (email, search) =>
  `/my-assets?email=${email}&search=${search}`;

export const API_AUDIO_CHAT = "/audio-chat";
export const API_VIDEO_CHAT = "/video-chat";
export const API_DESCRIPTIVE = "/descriptive";
export const API_DESCRIPTIVE_EVALUATE = "/descriptive/evaluate";
export const apiHide = (asset_id) => `assets/${asset_id}/hide`;
export const apiUnHide = (asset_id) => `assets/${asset_id}/unhide`;
export const API_GET_BOARD = "signup/filters/board";
export const API_GET_EDUCTION_LEVEL = "signup/filters/education_level";
export const API_GET_GENDER = "signup/filters/gender";
export const API_GET_CLASS_GRADE = "signup/filters/class_grade";
export const API_GET_FOCUS = "signup/filters/focus";
export const API_GET_MEDIUM_OF_INSTRUCTION =
  "signup/filters/medium_of_instruction";
export const API_GET_List_MEDIUM_OF_INSTRUCTION =
  "signup/list/filters/medium_of_instruction";

export const API_STUDENT_ASSET_URL = "/students/get-asset-url";

//UPSC
export const API_MEDIUM_TNPSC = "/upsc/mediums";
export const API_PAPERS_UPSC = "/upsc/papers";
export const API_SUBJECTS_UPSC = "upsc/subjects";
export const API_CHAPTERS_TNPSC = "/upsc/chapters";
export const API_PARTS_TNPSC = "/tnpsc/parts";
export const API_UNIT_TN = "/tnpsc/units";
export const API_LESSON_TN = "/tnpsc/lessons";
export const API_CHPATER_TN = "/tnpsc/chapters";
export const API_UNITS_TNPSC = "/upsc/units";
export const API_LESSONS_TNPSC = "/upsc/lessons";
export const API_AI_CONTENT_LESSON = "/ai-content/tnpsc/lessons";
export const API_AI_CONTENT_UPSC_LESSON = "/ai-content/upsc/lessons";
export const API_GET_MCQ_TNPSC = "/upsc/mcq";
export const API_GET_MCQ_TN = "/tnpsc/mcq";
export const API_MCQ_TNPSC = "/upsc/ask";
export const API_MCQ_TN = "/tnpsc/ask";
export const API_DESCRIPTIVE_EVALUATE_UPSC = "/upsc/descriptive/evaluate";
export const API_DESCRIPTIVE_MCQ_UPSC = "/upsc/descriptive/questions";
export const API_DESCRIPTIVE_EXAM_UPSC = "/upsc-descriptive/exams";
export const API_DESCRIPTIVE_YEAR_UPSC = "/upsc-descriptive/year";
export const API_DESCRIPTIVE_SUBJECT_UPSC = "/upsc-descriptive/subject";
export const API_DESCRIPTIVE_MEDIUM_UPSC = "/upsc-descriptive/medium";
export const API_DESCRIPTIVE_TOPIC_UPSC = "/upsc-descriptive/topic";
export const API_DESCRIPTIVE_MARK_UPSC = "/upsc-descriptive/marks";
export const API_DESCRIPTIVE_QUEST_TYPE_UPSC =
  "/upsc-descriptive/question_type";
export const API_EVALUATE_TNPSC = "/upsc/evaluate";
export const API_EVALUATE_TN = "/tnpsc/evaluate";
// export const API_REMOVE_MULTIPLE = "/users/remove-multiple"
// export const API_SCHOOL_DETAILS = "/schools"
// export const apiGetMyStuff = (email) => `/my-short-stuff?email=${email}`
export const API_SHORT_MULTI_TNPSC = "/upsc/shorts/multi";
export const API_SHORT_MULTI_TN = "/upsc/tnpsc/multi";
// export const apiChatHistory = (email, limit) => `/chat/history?email=${email}&limit=${limit}`
export const apiChatHistoryFilterTnpsc = (
  email,
  board,
  clas,
  medium,
  part,
  unit,
  chapter,
  lesson,
  language,
) =>
  `/upsc/chat/history/filter?email=${email}&board=${board}&clas=${clas}&medium=${medium}&part=${part} &unit=${unit}&chapter=${chapter}&lesson=${lesson}&language=${language}`;
export const API_LONG_MULTI_TNPSC = "/upsc/long-job/multi";
export const API_LONG_MULTI_TN = "/tnpsc/long-job/multi";
export const API_RANDOM_TNPSC = "upsc/random/content";
export const API_RANDOM_MULTI_TNPSC = "tnpsc/random/content";
export const API_COMPETITIVE_EXAM = "pyq/competitive/exams";
export const API_COMPETITIVE_YEAR = "pyq/competitive/year";
export const API_COMPETITIVE_MEDIUIM = "pyq/competitive/medium";
export const API_COMPETITIVE_PAPER = "pyq/competitive/paper";
export const API_PYQ_COMPETITIVE = "/pyq/competitive";
export const API_PYQ_COMPETITIVE_EVALUATE = "/pyq/competitive/evaluate";
export const API_PYQ_EXAM = "/pyq/exam";
export const API_PYQ_EXAM_YEAR = "/pyq/exam/year";
export const API_PYQ_EXAM_EVALUATE = "/pyq/exam/evaluate";
export const API_UPSC_ASSET_URL = "/upsc/get-asset-url";
export const apiMyAssestsTnpsc = (
  email,
  type,
  status,
  language,
  sort,
  subject,
  chapter,
  include_hidden,
  on_date,
  from_date,
  to_date,
) => {
  let url = `/upsc/my-assets?email=${email}&type=${type}&sort=${sort}`;
  if (status) url += `&status=${status}`;
  if (language) url += `&language=${language}`;
  if (subject) url += `&subject=${subject}`;
  if (chapter) url += `&chapter=${chapter}`;
  if (include_hidden) url += `&include_hidden=${include_hidden}`;
  if (on_date) url += `&on_date=${on_date}`;
  if (from_date) url += `&from_date=${from_date}`;
  if (to_date) url += `&to_date=${to_date}`;
  return url;
};
export const apiMyAssestsUpscSearch = (email, search) =>
  `/upsc/my-assets?email=${email}&search=${search}`;

export const apiMyAssestsTn = (
  email,
  type,
  status,
  language,
  sort,
  subject,
  chapter,
  include_hidden,
  on_date,
  from_date,
  to_date,
) => {
  let url = `/tnpsc/my-assets?email=${email}&type=${type}&sort=${sort}`;
  if (status) url += `&status=${status}`;
  if (language) url += `&language=${language}`;
  if (subject) url += `&subject=${subject}`;
  if (chapter) url += `&chapter=${chapter}`;
  if (include_hidden) url += `&include_hidden=${include_hidden}`;
  if (on_date) url += `&on_date=${on_date}`;
  if (from_date) url += `&from_date=${from_date}`;
  if (to_date) url += `&to_date=${to_date}`;
  return url;
};
export const apiMyAssestsTnpscSearch = (email, search) =>
  `/tnpsc/my-assets?email=${email}&search=${search}`;
export const API_GENERATE_VIDEO_TNPSC = "/aspirant/tnpsc/generate-video";

export const apiHideTnpsc = (asset_id) => `/upsc/assets/${asset_id}/hide`;
export const apiUnHideTnpsc = (asset_id) => `/upsc/assets/${asset_id}/unhide`;
export const API_GENERATE_VIDEO_UPSC = "/aspirant/upsc/generate-video";

//TNPSC OR UPSC
// export const API_MEDIUM_TNPSC = "/tnpsc/mediums";
// export const API_CHAPTERS_TNPSC = "/tnpsc/chapters";
// export const API_PARTS_TNPSC = "/tnpsc/parts";
// export const API_UNITS_TNPSC = "/tnpsc/units";
// export const API_LESSONS_TNPSC = "/tnpsc/lessons";
// export const API_AI_CONTENT_LESSON = "/ai-content/tnpsc/lessons";
// export const API_GET_MCQ_TNPSC = "/tnpsc/mcq";
// export const API_MCQ_TNPSC = "/tnpsc/ask";
// export const API_EVALUATE_TNPSC = "/tnpsc/evaluate";
// export const API_SHORT_MULTI_TNPSC = "/tnpsc/shorts/multi";
// export const apiChatHistoryFilterTnpsc = (email,board,clas,medium,part,unit, chapter,lesson,language, ) =>
//   `tnpsc/chat/history/filter?email=${email}&board=${board}&clas=${clas}&medium=${medium}&part=${part} &unit=${unit}&chapter=${chapter}&lesson=${lesson}&language=${language}`;
// export const API_LONG_MULTI_TNPSC = "/tnpsc/long-job/multi";
// export const API_RANDOM_TNPSC="tnpsc/random/content"
// export const API_COMPETITIVE_EXAM="pyq/competitive/exams"
// export const API_COMPETITIVE_YEAR="pyq/competitive/year"
// export const API_COMPETITIVE_MEDIUIM="pyq/competitive/medium"
// export const API_COMPETITIVE_PAPER="pyq/competitive/paper"
// export const apiMyAssestsTnpsc = (
//   email,
//   type,
//   status,
//   sort,
//   subject,
//   chapter,
//   include_hidden,
//   on_date,
//   from_date,
//   to_date,
// ) => {
//   let url = `/tnpsc/my-assets?email=${email}&type=${type}&sort=${sort}`;
//   if (status) url += `&status=${status}`;
//   if (subject) url += `&subject=${subject}`;
//   if (chapter) url += `&chapter=${chapter}`;
//   if (include_hidden) url += `&include_hidden=${include_hidden}`;
//   if (on_date) url += `&on_date=${on_date}`;
//   if (from_date) url += `&from_date=${from_date}`;
//   if (to_date) url += `&to_date=${to_date}`;
//   return url;
// };

// export const apiHideTnpsc = (asset_id) => `/tnpsc/assets/${asset_id}/hide`;
// export const apiUnHideTnpsc = (asset_id) => `/tnpsc/assets/${asset_id}/unhide`;

// NEET or JEE
export const API_EXAM = "/exams";
export const API_EXAM_CONTENT_CHAPTERS = "/ai-content/exam-chapters";
export const API_EXAM_SUBJECTS = "/exam-subjects";
export const API_EXAM_CHAPTERS = "/exam-chapters";
export const API_GET_EXAM_MCQ = "/exam/mcq";
export const API_EXAM_MCQ = "/exam/ask";
export const API_EXAM_MCQ_SUBJECTS = "/exam/mcq/subjects";
export const API_EXAM_MCQ_CHAPTERS = "/exam/mcq/chapters";
export const API_EXAM_EVALUATE = "/exam/evaluate";
export const API_EXAM_REMOVE_MULTIPLE = "/users/remove-multiple";
export const API_EXAM_SCHOOL_DETAILS = "/schools";
export const apiGetMyStuffExam = (email) => `/my-short-stuff?email=${email}`;
export const API_EXAM_SHORT_MULTI = "/exam/shorts/multi";
export const apiChatHistoryExam = (email, limit) =>
  `/chat/history?email=${email}&limit=${limit}`;
export const apiChatHistoryExamFilter = (email, subject, chapter) =>
  `/exam/chat/history/filter?email=${email}&subject=${subject}&chapter=${chapter}`;
export const API_EXAM_LONG_MULTI = "/exam/long-job/multi";
export const API_EXAM_RANDOM_MULTI = "/exam/random/content";

export const API_EXAM_DEACTIVATE_USERS = "/users/deactivate-multiple";
export const API_EXAM_ACTIVATE_USERS = "/users/activate-multiple";
export const apiMyAssestsExams = (
  email,
  examType,
  type,
  status,
  language,
  sort,
  subject,
  chapter,
  include_hidden,
  on_date,
  from_date,
  to_date,
) => {
  const validExam = examType && examType !== "undefined" ? examType : "NEET";
  let url = `/exam/my-assets?email=${email}&type=${type}&sort=${sort}&exam=${validExam}`;
  if (status) url += `&status=${status}`;
  if (language) url += `&language=${language}`;
  if (subject) url += `&subject=${subject}`;
  if (chapter) url += `&chapter=${chapter}`;
  if (include_hidden) url += `&include_hidden=${include_hidden}`;
  if (on_date) url += `&on_date=${on_date}`;
  if (from_date) url += `&from_date=${from_date}`;
  if (to_date) url += `&to_date=${to_date}`;
  return url;
};
export const apiMyAssestsExamSearch = (email, search, exam = "NEET") => {
  const validExam = exam && exam !== "undefined" ? exam : "NEET";
  return `/exam/my-assets?email=${email}&search=${search}&exam=${validExam}`;
};

export const API_ASSEST_URL = "/exam/get-asset-url";
export const API_EXAM_DESCRIPTIVE_EVALUATE = "/descriptive/evaluate";
export const apiHideExam = (asset_id) => `/exam/assets/${asset_id}/hide`;
export const apiUnHideExam = (asset_id) => `/exam/assets/${asset_id}/unhide`;
export const API_EXAM_MY_ASSESTS = "/exam/my-assets";
export const apiMyAssestsRenameExam = (asset_id) =>
  `/exam/assets/${asset_id}/rename`;

// Live Avatar APIs
export const API_AVATAR_START = "/avatar/start";
export const API_AVATAR_STOP = "/avatar/stop";
export const API_AVATAR_ASK = "/avatar/ask";
export const API_AVATAR_LOG = "/avatar/log";
export const API_AVATAR_TNPSC_ASK = "/avatar/tnpsc/ask";
export const API_AVATAR_UPSC_ASK = "/avatar/upsc/ask";
export const API_AVATAR_EXAM_ASK = "/avatar/exam/ask";
export const API_EVALUATE_DESCRIPTIVE_AVATAR = "/descriptive/evaluate";
export const API_EVALUATE_DESCRIPTIVE_TYPO = "/descriptive/typo/evaluate";
export const API_GENERATE_VIDO_NEET = "/entrance/student/generate-video";

// user dashboard
export const API_USER_DASHBOARD = "/dashboard";

// user profile update
export const API_USER_PROFILE_UPDATE = "/users/update-exam-type";
export const API_COUNT_MCQ = "/mcq/count";

// Admin Access Requests
export const API_ADMIN_ACCESS_REQUESTS_STATS = "/admin/access-requests/stats";
export const API_ADMIN_ACCESS_REQUESTS = "/admin/access-requests";
export const API_ADMIN_UPDATE_ACCESS_REQUEST = "/admin/update-access-request";
export const API_ADMIN_BULK_UPDATE_ACCESS_REQUESTS =
  "/admin/access-requests/bulk-update";
export const API_ADMIN_ACCESS_REQUESTS_EXAMS = "/admin/access-requests/exams";
export const API_REQUEST_ACCESS_EXAM = "/request-access";
export const apiGetCompatitiveExam = (email) =>
  `/user/competitive-exams?mail=${email}`;
export const apiGetApprovedCourses = (email) =>
  `user/approved-courses?mail=${email}`;
export const API_COURSES = "/room/course_types";
export const apiCourseFilter = (course_type) => `/room/filters/${course_type}`;
export const API_CREATE_ROOM = "room/create";
export const API_JOIN_ROOM = "/room/join";
export const apiAcyncQuizProgress = (code) => `/room/${code}/progress`;
export const apiRoomProgressGoogle = (code) => `/room/${code}/progress-google`;
export const apiCloseRoom = (code, mail) => `/room/${code}/close?mail=${mail}`;
export const apiCodeJoinResults = (code) => `/room/${code}/results`;
export const apiRoomAsyncQuestions = (code, mail) =>
  `/room/${code}/questions?mail=${mail}`;
export const apiAsyncSubmit = (code) => `/room/${code}/submit`;
export const apiLeaderBoard = (code) => `/room/${code}/leaderboard`;
export const apiJoinRoomHistory = (mail) =>
  `/room/history/student?mail=${mail}`;
export const apiStudentUpcomingTests = (email) =>
  `/student/upcoming-tests?student_email=${encodeURIComponent(email)}`;
export const apiTeacherStudentSubtopic = (email, subject, arg3, arg4) => {
  const chapter = arg4 !== undefined ? arg4 : arg3;
  return `/api/teacher/student/${encodeURIComponent(email)}/weakness-details/subtopic?subject=${encodeURIComponent(subject)}&chapter=${encodeURIComponent(chapter)}`;
};
export const apiStudentTestQuestionDetails = (testName, email, roomCode = "") => {
  let url = `/api/student/test-question-details?test_name=${encodeURIComponent(testName)}&email=${encodeURIComponent(email)}`;
  if (roomCode && roomCode !== "null" && roomCode !== "undefined") {
    url += `&room_code=${encodeURIComponent(roomCode)}`;
  }
  return url;
};
export const apiStudentAiSummary = (roomCode, email) =>
  `/room/${encodeURIComponent(roomCode)}/student-ai-summary?mail=${encodeURIComponent(email)}`;
export const apiHostHistory = (mail) => `/room/history/host?mail=${mail}`;
// export const apiGetPlans = (course) => `/plans?course=${course}`;
export const apiGetPlans = (courses = []) =>
  `/plans/multi?${courses
    .map((course) => `courses=${encodeURIComponent(course)}`)
    .join("&")}`;
export const API_REQUEST_ACCESS = "/v1/request-access";
export const API_FOCUS = "/v1/focus";
export const API_SUBMIT_PAYMENT_PROOF = "/submit-payment-proof";
export const apiCancelPayment = (order_id) =>
  `/cancel-payment?order_id=${order_id}`;
export const apiPaymentSummary = (order_id) =>
  `/payment/summary?order_id=${order_id}`;
export const API_LOGOUT = "/logout";

// Banking
export const API_BANKING_EXAMS = "/banking/exams";
export const API_BANKING_SECTIONS = "/banking/sections";
export const API_BANKING_SUBJECTS = "/banking/subjects";
export const API_BANKING_CHAPTERS = "/banking/chapters";
export const API_AVATAR_BANKING_ASK = "/avatar/banking/ask";
export const API_BANKING_ASK = "/banking/ask";
export const API_BANKING_CONCEPTS = "/ai-content/banking/concepts";
export const apiChatHistoryFilterBanking = (
  email,
  board,
  clas,
  medium,
  section,
  subject,
  chapter,
  exam,
  language,
) =>
  `/banking/chat/history/filter?email=${email}&board=${board}&clas=${clas}&medium=${medium}&section=${section}&subject=${subject}&chapter=${chapter}&exam=${exam}&language=${language}`;
export const API_GENERATE_VIDEO_BANKING = "/aspirant/banking/generate-video";
export const API_LONG_MULTI_BANKING = "/banking/long-job/multi";
export const API_RANDOM_BANKING = "/banking/random/content";
export const apiMyAssestsBankingSearch = (email, search) =>
  `/banking/my-assets?email=${email}&search=${search}`;
export const API_SHORT_MULTI_BANKING = "/banking/shorts/multi";
export const API_COMPETITIVE_EXAM_BANKING = "pyq/banking/exams";
export const API_COMPETITIVE_YEAR_BANKING = "pyq/banking/year";
export const API_COMPETITIVE_PAPER_BANKING = "pyq/banking/paper";
export const API_PYQ_BANKING = "/pyq/banking";
export const API_PYQ_BANKING_EVALUATE = "/pyq/banking/evaluate";
export const apiMyAssestsBanking = (
  email,
  type,
  status,
  language,
  sort,
  subject,
  chapter,
  include_hidden,
  on_date,
  from_date,
  to_date,
) => {
  let url = `/banking/my-assets?email=${email}&type=${type}&sort=${sort}`;
  if (status) url += `&status=${status}`;
  if (language) url += `&language=${language}`;
  if (subject) url += `&subject=${subject}`;
  if (chapter) url += `&chapter=${chapter}`;
  if (include_hidden) url += `&include_hidden=${include_hidden}`;
  if (on_date) url += `&on_date=${on_date}`;
  if (from_date) url += `&from_date=${from_date}`;
  if (to_date) url += `&to_date=${to_date}`;
  return url;
};

export const apiCommunicativeProgress = (userMail) =>
  `/english/progress/${userMail}`;
export const API_CONVERSATION_START = "/english/conversation/start";

// POST /english/conversation/chat
export const API_CONVERSATION_CHAT = "/english/conversation/chat";

// POST /english/conversation/end
export const API_CONVERSATION_END = "/english/conversation/end";

export const API_VOCABULARY_DAILY_WORDS = "english/vocabulary/daily";
export const API_VOCABULARY_QUIZ = "english/vocabulary/quiz";
export const API_VOCABULARY_QUIZ_SUBMIT = "english/vocabulary/quiz/submit";
export const API_GRAMMAR_EXERCISE = "english/grammar/exercise";
export const API_GRAMMAR_SUBMIT = "english/grammar/submit";

export const apiReadingPassageGetApi = (classLevels, difficulties, topics) =>
  `/english/reading/passage?class_level=${classLevels}&difficulty=${difficulties}&category=${topics}`;

export const API_READING_PASSAGE = "/english/reading/submit";

//TEACHER MODULE
export const apiTeacherRoom = (host_mail, mode = "") =>
  `teacher/rovian/rooms?host_mail=${host_mail}&mode=${mode}`;

export const apiTestCategories = (email, role = "teacher") =>
  `/teacher/test/categories?email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}`;

export const apiTestExams = (email, role = "teacher") =>
  `/teacher/test/exams?email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}`;

export const apiTestClasses = (exam, email, role = "teacher") =>
  `/teacher/test/classes?exam=${encodeURIComponent(exam)}&email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}`;

export const apiTestChapters = (exam, param2 = "", param3 = "teacher", param4 = "") => {
  let email = "";
  let role = "teacher";
  let className = "";

  if (typeof param2 === "string" && param2.includes("@")) {
    email = param2;
    role = param3 || "teacher";
    className = param4 || "";
  } else {
    className = param2 || "";
    email = param3 || "";
    role = param4 || "teacher";
  }

  let url = `/teacher/test/chapters?exam=${encodeURIComponent(exam || "")}`;
  if (className) {
    url += `&class=${encodeURIComponent(className)}`;
  }
  if (email) {
    url += `&email=${encodeURIComponent(email)}`;
  }
  if (role) {
    url += `&role=${encodeURIComponent(role)}`;
  }
  return url;
};

export const apiTestSubTopics = (exam, chapter, email, role = "teacher") => {
  let chapterList = [];
  if (Array.isArray(chapter)) {
    chapterList = chapter;
  } else if (typeof chapter === "string" && chapter) {
    if (chapter.includes(",Chapter:")) {
      chapterList = chapter.split(/,(?=Chapter:)/);
    } else {
      chapterList = [chapter];
    }
  }
  const chapterStr = chapterList.map((ch) => mapChapterToNewName(ch.trim())).join(",");
  return `/teacher/test/sub-topics?exam=${encodeURIComponent(exam)}&chapter=${encodeURIComponent(chapterStr)}&email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}`;
};

export const API_CREATE_TEACHER_TEST = "/teacher/test/create";

export const apiTestList = (email, role = "teacher", page = 1, pageSize = 8, filters = {}) => {
  let url = `/teacher/test/list?email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}&page=${page}&page_size=${pageSize}`;
  if (filters?.testName) url += `&test_name=${encodeURIComponent(filters.testName)}`;
  if (filters?.testCategory) url += `&test_category=${encodeURIComponent(filters.testCategory)}`;
  if (filters?.exam) url += `&exam=${encodeURIComponent(filters.exam)}`;
  if (filters?.className) url += `&class=${encodeURIComponent(filters.className)}`;
  if (filters?.chapter) url += `&chapter=${encodeURIComponent(mapChapterToApiName(filters.chapter))}`;
  if (filters?.subTopic) url += `&sub_topic=${encodeURIComponent(filters.subTopic)}`;
  if (filters?.date) url += `&date=${encodeURIComponent(filters.date)}`;
  return url;
};

export const apiTeacherTestByName = (testName, email = "", role = "teacher") => {
  let url = `/teacher/tests/${encodeURIComponent(testName)}`;
  if (email) {
    url += `?email=${encodeURIComponent(email)}&role=${encodeURIComponent(role)}`;
  }
  return url;
};

export const apiTeacherStats = (examType, filterValue, extraParams = {}) => {
  const type = examType.toLowerCase();
  const params = new URLSearchParams(extraParams).toString();
  const query = params ? `?${params}` : "";
  if (type === "banking")
    return `/teacher/banking/stats/section/${filterValue}${query}`;
  if (type === "upsc")
    return `/teacher/upsc/stats/paper/${filterValue}${query}`;
  if (type === "tnpsc")
    return `/teacher/tnpsc/stats/part/${filterValue}${query}`;
  if (type === "cbse" || type === "student" || type === "tn_state_board")
    return `/teacher/student/stats/subject/${filterValue}${query}`;
  return `/teacher/exam/stats/subject/${filterValue}${query}`;
};

export const apiAdminChapters = (examType) => {
  const type = examType?.toLowerCase();
  if (type === "upsc") return `/admin/${type}/lessons`;
  if (type === "cbse" || type === "student" || type === "tn_state_board")
    return `/admin/student/chapters`;
  if (type === "neet" || type === "jee") return `/admin/exam/chapters`;
  return `/admin/${type}/chapters`;
};
export const API_ADMIN_BANKING_SUBJECTS = "/admin/banking/subjects";
export const API_ADMIN_STUDENT_SUBJECTS = "/admin/student/subjects";
export const API_ADMIN_UPSC_SUBJECTS = "/admin/upsc/subjects";
export const API_ADMIN_UPSC_UNITS = "/admin/upsc/units";
export const API_ADMIN_TNPSC_UNITS = "/admin/tnpsc/units";
export const apiAdminUploadContent = (examType) => {
  const type = examType?.toLowerCase();
  if (type === "tn_state_board") return `/admin/tnstateboard/upload-content`;
  return `/admin/${type}/upload-content`;
};
export const apiAdminKnowledgeBase = (examType, medium) => {
  const type = examType?.toLowerCase();
  const med = medium?.toLowerCase();
  const path = type === "tn_state_board" ? "tnstateboard" : type;

  if (type === "cbse" || type === "tnpsc" || type === "tn_state_board") {
    if (med === "english" || med === "hindi" || med === "tamil") {
      return `/admin/${path}/${med}/knowledgebase`;
    }
  }

  return `/admin/${path}/knowledgebase`;
};

export const API_VIDEO_MARK = "/video/mark-completed";
export const API_LEARNING_CHALLENGE_UPDATE =
  "/learning-challenge/update-progress";

export const apiGetLearningChallenge = (email) =>
  `/learning-challenge/history?email=${email}`;

export const API_LEARNING_CREATE = "/learning-challenge/create";

export const API_SIGN_UP_COUNTRIES = "/signup/countries";
export const API_SIGN_UP_FILTER_COUNTRIES = "/signup/filters/country";
export const apiSignupState = (country) => `/signup/states?country=${country}`;
export const apiSignupCity = (country, state) =>
  `/signup/cities?country=${country}&state=${state}`;
export const API_LEARNING_PREFERENCE = "/v1/learning_preferences";
export const API_V1_FOCUES = "/v1/focus";
export const apiLearingPath = (email) => `/v1/learning_path?email=${email}`;
export const API_SIGNUP_COUNTRY_CODE = "/signup/filters/country-code";
export const API_TEMP_LOGIN = "/temp/login";
export const API_QUESTIONS_UPLOAD = "/api/questions/import"

